import React, { useState, useEffect } from "react";
import axios from "axios";
import AvailabilityRow from "./AvailabilityRow"; // Assuming this component is reusable for displaying data
import Swal from "sweetalert2";
import API_BASE_URL from "../config";
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;
export const showToast = (title, icon = "success") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title,
  });
};

export default function EventAvailability({ userId }) {
  const [availability, setAvailability] = useState([]);
  const weekdays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [timezone, setTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  useEffect(() => {
    const fetchAvailability = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/user/${userId}/availability`
        );
        // Flatten the API structure to what AvailabilityRow expects
        const flatSlots = response.data.availability.flatMap((day) =>
          day.slots.map((slot) => ({
            day: day.day,
            start: slot.start,
            end: slot.end,
            availability: slot.availability,
            enabled: slot.enabled !== undefined ? slot.enabled : true, // fallback to true
          }))
        );
        setAvailability(flatSlots);
      } catch (error) {
        console.error("Error fetching availability data", error);
        showToast("Failed to load availability.", "error");
      }
    };

    fetchAvailability();
  }, [userId]);

  return (
    <div className="space-y-4">
      <div class="title-line2">
        <h5 class="mb-0 fw700">Availability</h5>
      </div>
      <p>Timezone: {timezone}</p>
      {weekdays.map((day) => {
        // Get the availability for this particular day from the 'availability' state
        const dayAvailability = availability.filter((slot) => slot.day === day);

        return (
          <div className="row">
            <AvailabilityRow
              key={day}
              day={day}
              availability={dayAvailability}
              setAvailability={setAvailability}
              readOnly={true}
            />
          </div>
        );
      })}
    </div>
  );
}
